/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as MultistreamDefs from "./defs.defs.js";

const $nsid = "place.stream.multistream.listTargets";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"minimum":1,"maximum":100}), 50)),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"targets":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<MultistreamDefs.TargetView>((() => MultistreamDefs.targetView) as any), ),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** List a range of targets for rebroadcasting a Streamplace stream. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;

type Record$0 = { $type?: "place.stream.multistream.listTargets#record";"uri":l.AtUriString;"cid":l.CidString;"value":l.LexMap };

export type { Record$0 as Record };

const record$0 = /*#__PURE__*/ l.typedObject<Record$0>($nsid, "record", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"cid":/*#__PURE__*/ l.string({"format":"cid"}),"value":/*#__PURE__*/ l.lexMap()}));

export { record$0 as record };
